// Asset mapping for Figma-extracted assets
// This file maps the original localhost URLs to the new asset paths

export const ASSET_MAPPING = {
  // Main Page Images (PNG)
  '7f12ea1300756f144a0fb5daaf68dbfc01103a46.png': '/assets/7f12ea1300756f144a0fb5daaf68dbfc01103a46.png', // Type video background
  '69ec944ddc47813e9abbf47191e897d62504b231.png': '/assets/69ec944ddc47813e9abbf47191e897d62504b231.png', // Logo color alter
  '9b66031505a877116f4c7a3afe4395dc0ac57f1a.png': '/assets/9b66031505a877116f4c7a3afe4395dc0ac57f1a.png', // Slider card 1
  '780e8492e34d131a371fcdec3038b886c3cc4618.png': '/assets/780e8492e34d131a371fcdec3038b886c3cc4618.png', // Slider card 2
  '9311bbfa884c553ba5b8cbfae6cc1ee7eeadd88b.png': '/assets/9311bbfa884c553ba5b8cbfae6cc1ee7eeadd88b.png', // Slider card 3
  '0db6dec23a4ae495bcfe43368d1ce50120889efe.png': '/assets/0db6dec23a4ae495bcfe43368d1ce50120889efe.png', // Slider card 4
  '333f5ec50c0fa5da465325f7aa881d1a984a7793.png': '/assets/333f5ec50c0fa5da465325f7aa881d1a984a7793.png', // Slider card 5
  'd229f375392d6de5150fa2675a9dafaaab74e2fd.png': '/assets/d229f375392d6de5150fa2675a9dafaaab74e2fd.png', // Slider card 6
  'f9c33abc828a08b002d09e54bc24d6a8494efe62.png': '/assets/f9c33abc828a08b002d09e54bc24d6a8494efe62.png', // Slider card 7
  'b75be6a4db7a535c72fc8b07f717138509ff8844.png': '/assets/b75be6a4db7a535c72fc8b07f717138509ff8844.png', // Slider card 8
  'dd1efa11075d600ce9a9b66a37cc155087aa8834.png': '/assets/dd1efa11075d600ce9a9b66a37cc155087aa8834.png', // Slider card 9

  // Avatar Images (PNG)
  'a6c63a503028a6cb43bba5171ff25544f8e4a12f.png': '/assets/a6c63a503028a6cb43bba5171ff25544f8e4a12f.png', // Avatar placeholder
  'cb2aa66c5a035915c65000bfa3659b499ac00093.png': '/assets/cb2aa66c5a035915c65000bfa3659b499ac00093.png', // Avatar 1
  '9a0b2bd896447b97a5280d8b93b623d5cf7ce31e.png': '/assets/9a0b2bd896447b97a5280d8b93b623d5cf7ce31e.png', // Avatar 2

  // Main Page Icons (SVG)
  '5de55fe31439c569f70893518a306422fc4b160a.svg': '/assets/5de55fe31439c569f70893518a306422fc4b160a.svg', // Ellipse 33 background
  '42fac7fdb9dd310b122110fe08166f9c81d5ef3c.svg': '/assets/42fac7fdb9dd310b122110fe08166f9c81d5ef3c.svg', // AI Chat icon
  '156107c15c85a7d799523a142cbe0b8e4261cbcb.svg': '/assets/156107c15c85a7d799523a142cbe0b8e4261cbcb.svg', // Star icon
  '408083dae55da1bc6124babacdd89563f1875f7f.svg': '/assets/408083dae55da1bc6124babacdd89563f1875f7f.svg', // Plus icon
  '0114189f46adc519aa9dfe93d0f47b9fdb36ee84.svg': '/assets/0114189f46adc519aa9dfe93d0f47b9fdb36ee84.svg', // Magic wand icon
  '0ef57895373811d83dd4c4427cbb933a51235d15.svg': '/assets/0ef57895373811d83dd4c4427cbb933a51235d15.svg', // Arrow icon
  '8966e1670a798c4c8f8c7370e56e34e758e3c0f9.svg': '/assets/8966e1670a798c4c8f8c7370e56e34e758e3c0f9.svg', // Footer logo
  '4499e028ea6e3ede7d5d4beaef2d3feeba7f00a9.svg': '/assets/4499e028ea6e3ede7d5d4beaef2d3feeba7f00a9.svg', // Footer divider

  // BIGVU Icons (SVG)
  '41aa7d5551ba7e82f3f225c830526821d4f6037b.svg': '/assets/41aa7d5551ba7e82f3f225c830526821d4f6037b.svg', // BIGVU icon
  'd8a5ccb335d246474f5c7f7aabee782a49ff18ff.svg': '/assets/d8a5ccb335d246474f5c7f7aabee782a49ff18ff.svg', // BIGVU logo

  // UI Icons (SVG)
  '34eb222b90bd31bbb7095ef02f014a5b3f0002d7.svg': '/assets/34eb222b90bd31bbb7095ef02f014a5b3f0002d7.svg', // Circle/credits icon
  '5d0b5940e65df17a8b481949b91d65ebf6d4f0ed.svg': '/assets/5d0b5940e65df17a8b481949b91d65ebf6d4f0ed.svg', // Copy icon
  'd26a2cf7013355bf3a49a07a8975dd5564bf3d6d.svg': '/assets/d26a2cf7013355bf3a49a07a8975dd5564bf3d6d.svg', // Download icon
  'bb0d979d723c56815615858fa72c0b21a056c120.svg': '/assets/bb0d979d723c56815615858fa72c0b21a056c120.svg', // Share icon

  // Action Icons (SVG)
  '092ff097caef9d50bd487184ee25c65af9106be9.svg': '/assets/092ff097caef9d50bd487184ee25c65af9106be9.svg', // Download icon
  '1f08fe19b9a1567e00b488ef6c4e2c3103673a29.svg': '/assets/1f08fe19b9a1567e00b488ef6c4e2c3103673a29.svg', // User icon
  '50b70f0f1102faff04e41bb88b799582f8770be5.svg': '/assets/50b70f0f1102faff04e41bb88b799582f8770be5.svg', // Presenter icon
  'a5363a1ded093bab30fb4451c028f4b6e2a3a1f4.svg': '/assets/a5363a1ded093bab30fb4451c028f4b6e2a3a1f4.svg', // Premium crown
  '37cf3ba53d117a87884dd750f7cd336653a5ae85.svg': '/assets/37cf3ba53d117a87884dd750f7cd336653a5ae85.svg', // AI video icon
  '686f78c237bf4fd18d32d549edfa9564233ba35a.svg': '/assets/686f78c237bf4fd18d32d549edfa9564233ba35a.svg', // Video icon
  'c0b702d233c7e84c12ff465a1533b6e459b6ce70.svg': '/assets/c0b702d233c7e84c12ff465a1533b6e459b6ce70.svg', // Premium diamond
  '29c5fe53cfe46b88cc74b0b35b9900c8dd5821a3.svg': '/assets/29c5fe53cfe46b88cc74b0b35b9900c8dd5821a3.svg', // AI icon
  '5cefc8174839704e73e3fd21650651de256f86c0.svg': '/assets/5cefc8174839704e73e3fd21650651de256f86c0.svg', // Share icon

  // Additional Icons (SVG)
  '272717e6800be4a657404ba2556a7dbeede7f509.svg': '/assets/272717e6800be4a657404ba2556a7dbeede7f509.svg', // Additional icon 1
  '37efdf95ea9a7d7be1bff912fd985ee94895c8fb.svg': '/assets/37efdf95ea9a7d7be1bff912fd985ee94895c8fb.svg', // Additional icon 2
  '806ee121e9c81edc3547f3ec5f852fa8b5340cb5.svg': '/assets/806ee121e9c81edc3547f3ec5f852fa8b5340cb5.svg', // Additional icon 3
  'a2d02ba9b66ae03d75831790e5643bc79582d5a7.svg': '/assets/a2d02ba9b66ae03d75831790e5643bc79582d5a7.svg', // Additional icon 4
  'a48783496230c5dee4d68e3c516ebdfab4b8fff9.svg': '/assets/a48783496230c5dee4d68e3c516ebdfab4b8fff9.svg', // Additional icon 5
  '110239d204bc3046544e1802604f8f52c1799eb3.svg': '/assets/110239d204bc3046544e1802604f8f52c1799eb3.svg', // Additional icon 6

  // New Figma Assets (SVG)
  '5194e657ac5df6df970c47d637a5827f1c51dc68.svg': '/assets/5194e657ac5df6df970c47d637a5827f1c51dc68.svg', // Timeline icon
  '722f4d8164326c38c0d9acec19b537797db09529.svg': '/assets/722f4d8164326c38c0d9acec19b537797db09529.svg', // Shape icon
  '4716f637b258e786415b1bd7cf492b0495b3baf8.svg': '/assets/4716f637b258e786415b1bd7cf492b0495b3baf8.svg', // Icon 1
  '5e0d01fd61daf2f6652181a7f5223d20daaf7be8.svg': '/assets/5e0d01fd61daf2f6652181a7f5223d20daaf7be8.svg', // Icon 2
  '0176e029896a5cd0cf767b6f7d9cd612348eaf8c.svg': '/assets/0176e029896a5cd0cf767b6f7d9cd612348eaf8c.svg', // Icon 3
  '07642a3219dadb674aae75a6617cb492dbe11e8a.svg': '/assets/07642a3219dadb674aae75a6617cb492dbe11e8a.svg', // Icon 4
  '6510b6214c3b35dec5e7d7362057dd2f6b5a5691.svg': '/assets/6510b6214c3b35dec5e7d7362057dd2f6b5a5691.svg', // Ellipse 142
  '300a34b1beff910d663eedc66ce796f434318505.svg': '/assets/300a34b1beff910d663eedc66ce796f434318505.svg', // Group 1385
  '862ee4ed288d4f1e9de99979a9c3579a774dcff5.png': '/assets/862ee4ed288d4f1e9de99979a9c3579a774dcff5.png', // Video image
  'e32cc44731b921df81f81850d03d4efce56fdef7.svg': '/assets/e32cc44731b921df81f81850d03d4efce56fdef7.svg', // Vector 25
  '3309bb1a113ef852fa4788e405174407beb0d003.svg': '/assets/3309bb1a113ef852fa4788e405174407beb0d003.svg', // Ribbon
  'c83721cf15721a5d6323297a249c15f9830845a3.svg': '/assets/c83721cf15721a5d6323297a249c15f9830845a3.svg', // Forever icon
  '83eff45e48ca8b6d704b40322291b7f7fa678ac9.svg': '/assets/83eff45e48ca8b6d704b40322291b7f7fa678ac9.svg', // Icon 5
  '6a3ad0f88735c375c85166453d47cb11384bfd2c.svg': '/assets/6a3ad0f88735c375c85166453d47cb11384bfd2c.svg', // Icon 6
  '8f2672749407c042b24dd3658991e632a8084939.svg': '/assets/8f2672749407c042b24dd3658991e632a8084939.svg', // Icon 7
  '20d6589bcf21338b26ed1176427d891509fc154b.svg': '/assets/20d6589bcf21338b26ed1176427d891509fc154b.svg', // Icon 8
  'b4ad1979e4bd2d6ea8e91cdc786f3a0b73de9af8.svg': '/assets/b4ad1979e4bd2d6ea8e91cdc786f3a0b73de9af8.svg', // Icon 9
  '6c7775fd244f744699b450870ae2a1a23e069249.svg': '/assets/6c7775fd244f744699b450870ae2a1a23e069249.svg', // Icon 10
  'db67315a5328f5561771a96e4fed8c5032ad20a8.svg': '/assets/db67315a5328f5561771a96e4fed8c5032ad20a8.svg', // Ellipse 141
  '51202f2c3255062fff825ba3b9e3bd9fc9c57edc.svg': '/assets/51202f2c3255062fff825ba3b9e3bd9fc9c57edc.svg', // Icon 11

  // Style Option Assets (PNG) - New from Figma design
  '9d1a252acc3fcdbc292412631e8eda38e7ffe5c0.png': '/assets/9d1a252acc3fcdbc292412631e8eda38e7ffe5c0.png', // Photorealistic style
  'd2302d1f8cd75571a1189f4c0d98508a267963e9.png': '/assets/d2302d1f8cd75571a1189f4c0d98508a267963e9.png', // Full-body scene

  // OutOfCreditsModal Assets (PNG/SVG) - New from Figma design
  'e02220b3086500919e516ba364aaa149ef47a87d.png': '/assets/e02220b3086500919e516ba364aaa149ef47a87d.png', // Esperanza portrait
  'adb99af289b94402bcfcf36e713b215a17fb6cbd.svg': '/assets/adb99af289b94402bcfcf36e713b215a17fb6cbd.svg', // Vector 13
  'f7df12b439df6381a17b1a05be28a732e64dc7d8.svg': '/assets/f7df12b439df6381a17b1a05be28a732e64dc7d8.svg', // Ellipse 41
  'b5243b7b67d2a586754ec6a3c7885d2d608718e0.svg': '/assets/b5243b7b67d2a586754ec6a3c7885d2d608718e0.svg', // Ellipse 42
  'e7abf98299f25418f496786cdbbb86d25ba74324.svg': '/assets/e7abf98299f25418f496786cdbbb86d25ba74324.svg', // Ellipse 39
  '85f877646c418a9ad0a068317ba1956e5c3ddba8.svg': '/assets/85f877646c418a9ad0a068317ba1956e5c3ddba8.svg', // Esperanza mask
  '04ecd754d0dca0344798b57f3a8b1ae05ce972c1.svg': '/assets/04ecd754d0dca0344798b57f3a8b1ae05ce972c1.svg', // Vector 64 stroke
  'c7a9671b2f47cd2c586096d716957408aa747e7c.svg': '/assets/c7a9671b2f47cd2c586096d716957408aa747e7c.svg', // Circle icon

  // SubmitModal Assets (PNG) - New from Figma design
  '10f0090abd72baa1a7a246c4159eb3a4cdac0cb9.png': '/assets/10f0090abd72baa1a7a246c4159eb3a4cdac0cb9.png', // Success confirmation image
  
  'brain.png': '/assets/icons/brain.png', // Brain image
  'AI Chat.svg': '/assets/icons/Prompt2Avatar/AI Chat.svg', // AI Chat icon
  'bigvu_icon_blur.png': '/assets/icons/Prompt2Avatar/bigvu_icon_blur.png', // BigVU icon blur
  'Alert.svg': '/assets/icons/Prompt2Avatar/Alert.svg', // Alert icon

} as const;

// Helper function to get asset path
export const getAssetPath = (originalPath: string): string => {
  const filename = originalPath.split('/').pop();
  if (filename && filename in ASSET_MAPPING) {
    return ASSET_MAPPING[filename as keyof typeof ASSET_MAPPING];
  }
  return originalPath; // Return original if not found
};

// Helper function to check if asset exists
export const assetExists = (assetPath: string): boolean => {
  try {
    // In a real app, you might want to check if the file exists
    // For now, we'll assume all mapped assets exist
    return assetPath.startsWith('/assets/');
  } catch {
    return false;
  }
};

// Asset constants for easy access
export const ASSETS = {
  // Main Page Images
  TYPE_VIDEO_BACKGROUND: '/assets/7f12ea1300756f144a0fb5daaf68dbfc01103a46.png',
  LOGO_COLOR_ALTER: '/assets/69ec944ddc47813e9abbf47191e897d62504b231.png',
  SLIDER_CARD_1: '/assets/9b66031505a877116f4c7a3afe4395dc0ac57f1a.png',
  SLIDER_CARD_2: '/assets/780e8492e34d131a371fcdec3038b886c3cc4618.png',
  SLIDER_CARD_3: '/assets/9311bbfa884c553ba5b8cbfae6cc1ee7eeadd88b.png',
  SLIDER_CARD_4: '/assets/0db6dec23a4ae495bcfe43368d1ce50120889efe.png',
  SLIDER_CARD_5: '/assets/333f5ec50c0fa5da465325f7aa881d1a984a7793.png',
  SLIDER_CARD_6: '/assets/d229f375392d6de5150fa2675a9dafaaab74e2fd.png',
  SLIDER_CARD_7: '/assets/f9c33abc828a08b002d09e54bc24d6a8494efe62.png',
  SLIDER_CARD_8: '/assets/b75be6a4db7a535c72fc8b07f717138509ff8844.png',
  SLIDER_CARD_9: '/assets/dd1efa11075d600ce9a9b66a37cc155087aa8834.png',

  // Avatar Images
  AVATAR_PLACEHOLDER: '/assets/a6c63a503028a6cb43bba5171ff25544f8e4a12f.png',
  AVATAR_1: '/assets/cb2aa66c5a035915c65000bfa3659b499ac00093.png',
  AVATAR_2: '/assets/9a0b2bd896447b97a5280d8b93b623d5cf7ce31e.png',
  
  // Main Page Icons
  ELLIPSE_33_BACKGROUND: '/assets/5de55fe31439c569f70893518a306422fc4b160a.svg',
  AI_CHAT_ICON1: '/assets/42fac7fdb9dd310b122110fe08166f9c81d5ef3c.svg',
  STAR_ICON: '/assets/156107c15c85a7d799523a142cbe0b8e4261cbcb.svg',
  PLUS_ICON: '/assets/408083dae55da1bc6124babacdd89563f1875f7f.svg',
  MAGIC_WAND_ICON: '/assets/0114189f46adc519aa9dfe93d0f47b9fdb36ee84.svg',
  ARROW_ICON: '/assets/0ef57895373811d83dd4c4427cbb933a51235d15.svg',
  FOOTER_LOGO: '/assets/8966e1670a798c4c8f8c7370e56e34e758e3c0f9.svg',
  FOOTER_DIVIDER: '/assets/4499e028ea6e3ede7d5d4beaef2d3feeba7f00a9.svg',
  
  // BIGVU Icons
  BIGVU_ICON: '/assets/icons/Prompt2Avatar/BIGVU Icon.svg',
  BIGVU_LOGO: '/assets/d8a5ccb335d246474f5c7f7aabee782a49ff18ff.svg',
  
  // UI Icons
  COPY_ICON: '/assets/5d0b5940e65df17a8b481949b91d65ebf6d4f0ed.svg',
  DOWNLOAD_ICON: '/assets/d26a2cf7013355bf3a49a07a8975dd5564bf3d6d.svg',
  SHARE_ICON: '/assets/bb0d979d723c56815615858fa72c0b21a056c120.svg',
  CIRCLE_CREDITS_ICON: '/assets/34eb222b90bd31bbb7095ef02f014a5b3f0002d7.svg',
  
  // Action Icons
  USER_ICON: '/assets/1f08fe19b9a1567e00b488ef6c4e2c3103673a29.svg',
  PRESENTER_ICON: '/assets/50b70f0f1102faff04e41bb88b799582f8770be5.svg',
  AI_VIDEO_ICON: '/assets/37cf3ba53d117a87884dd750f7cd336653a5ae85.svg',
  VIDEO_ICON: '/assets/686f78c237bf4fd18d32d549edfa9564233ba35a.svg',
  AI_ICON: '/assets/29c5fe53cfe46b88cc74b0b35b9900c8dd5821a3.svg',
  
  // Premium Icons
  PREMIUM_CROWN: '/assets/a5363a1ded093bab30fb4451c028f4b6e2a3a1f4.svg',
  PREMIUM_DIAMOND: '/assets/c0b702d233c7e84c12ff465a1533b6e459b6ce70.svg',

  // New Figma Assets
  TIMELINE_ICON: '/assets/5194e657ac5df6df970c47d637a5827f1c51dc68.svg',
  SHAPE_ICON: '/assets/722f4d8164326c38c0d9acec19b537797db09529.svg',
  VIDEO_IMAGE: '/assets/862ee4ed288d4f1e9de99979a9c3579a774dcff5.png',
  VECTOR_25: '/assets/e32cc44731b921df81f81850d03d4efce56fdef7.svg',
  RIBBON: '/assets/3309bb1a113ef852fa4788e405174407beb0d003.svg',
  FOREVER_ICON: '/assets/c83721cf15721a5d6323297a249c15f9830845a3.svg',
  ELLIPSE_141: '/assets/db67315a5328f5561771a96e4fed8c5032ad20a8.svg',
  ELLIPSE_142: '/assets/6510b6214c3b35dec5e7d7362057dd2f6b5a5691.svg',
  GROUP_1385: '/assets/300a34b1beff910d663eedc66ce796f434318505.svg',

  // Style Option Assets - New from Figma design
  PHOTOREALISTIC_STYLE: '/assets/9d1a252acc3fcdbc292412631e8eda38e7ffe5c0.png',
  CARTOON_STYLE: '/assets/7d5db14098c01d779566ee9e1241d7462ad5ac5f.png',
  VERTICAL_RATIO: '/assets/Frame 8073.svg',
  FULL_BODY_SCENE: '/assets/d2302d1f8cd75571a1189f4c0d98508a267963e9.png',

  // OutOfCreditsModal Assets - New from Figma design
  ESPERANZA_PORTRAIT: '/assets/e02220b3086500919e516ba364aaa149ef47a87d.png',
  VECTOR_13: '/assets/adb99af289b94402bcfcf36e713b215a17fb6cbd.svg',
  ELLIPSE_41: '/assets/f7df12b439df6381a17b1a05be28a732e64dc7d8.svg',
  ELLIPSE_42: '/assets/b5243b7b67d2a586754ec6a3c7885d2d608718e0.svg',
  ELLIPSE_39: '/assets/e7abf98299f25418f496786cdbbb86d25ba74324.svg',
  ESPERANZA_MASK: '/assets/85f877646c418a9ad0a068317ba1956e5c3ddba8.svg',
  VECTOR_64_STROKE: '/assets/04ecd754d0dca0344798b57f3a8b1ae05ce972c1.svg',
  CIRCLE_ICON: '/assets/c7a9671b2f47cd2c586096d716957408aa747e7c.svg',

  // SubmitModal Assets - New from Figma design
  SUCCESS_CONFIRMATION_IMAGE: '/assets/10f0090abd72baa1a7a246c4159eb3a4cdac0cb9.png',

  // Brain image
  BRAIN_IMAGE: '/assets/icons/brain.png',
  AI_CHAT_ICON: '/assets/icons/Prompt2Avatar/AI Chat.svg', // AI Chat icon
  BIGVU_ICON_BLUR: '/assets/icons/bigvu_icon_blur.png', // BigVU icon blur
  ALERT_ICON: '/assets/icons/Prompt2Avatar/Alert.svg', // Alert icon
} as const;